import React from 'react';
import VisitingClinicPage from './VisitingClinicPage';

const VisitingClinicMelbourne = () => (
  <VisitingClinicPage
    seo={{
      title: 'Autism, ADHD & Learning Assessments Melbourne | Clinical Minds Psychology',
      description: 'Full neurodevelopmental assessments at regular visiting clinics in Melbourne: autism, ADHD, FASD and learning disorders, children to adults. First appointment by Zoom, then one visit covers both assessment days. Enquire about upcoming clinic dates.',
      canonicalUrl: 'https://www.clinicalminds.net/visiting-clinics/melbourne'
    }}
    location="Melbourne"
    regionPhrase="Melbourne and regional Victoria"
  />
);

export default VisitingClinicMelbourne;
